import getTheme from 'commons/js/theme/getTheme'

export default getTheme()
